export default defineNuxtPlugin(() => {
  const authStore = useAuthStore()
  const profileStore = useProfileStore()
  const router = useRouter()
  const { mapPath } = usePath()
  const token = useCookie('token')

  // Initialiser le store depuis les cookies côté client
  authStore.initializeFromCookies()

  // Si l'utilisateur est authentifié ET qu'un token existe, charger le profil
  if (authStore.authenticated && token.value && !profileStore.profile) {
    profileStore.fetchProfile().then(() => {
      // Rediriger les étudiants et enseignants (sans double rôle responsable) vers leur planning après chargement du profil
      if (profileStore.userType === 'etudiant' && router.currentRoute.value.path === '/') {
        router.push(mapPath('/planning/calendar'))
      } else if (router.currentRoute.value.path === '/') {
        // Vérifier si l'utilisateur est Admin (Admin va au dashboard même s'il est aussi Enseignant)
        const groups = profileStore.profile?.groups ?? [];
        const hasAdminGroup = groups.some((g: any) => g.name === 'Admin');
        if (!hasAdminGroup) {
          // Vérifier si l'utilisateur est enseignant SANS être responsable pédagogique
          const isEnseignantOnly = profileStore.isEnseignant && 
            !groups.some((g: any) => g.name === 'Responsable pedagogique' || g.name === 'Pedagogie');
          if (isEnseignantOnly) {
            router.push(mapPath('/planning/enseignant'))
          }
        }
      }
    }).catch(() => {
      // En cas d'erreur, nettoyer le profil
      profileStore.clearProfile()
    })
  } else if (!token.value && profileStore.profile) {
    // Si pas de token mais qu'un profil existe, le nettoyer
    profileStore.clearProfile()
  }
}) 